import apiClient from './api_client_requests';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'CTLForgotPassword',
            headers: {},
            args: {
                email: payload.email,
            },
            urlArgs: {},
        });
        return result;
    };
};
